const sendMessage =  (number) => {
    window.open(`https://wa.me/55${number}?text=Olá,%20estou%20interessado%20em%20comprar%20um%20produto%20de%20sua%20farmácia.%20Obrigado!`)
}

export default sendMessage;